import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';

type PropsType = {
  onClickMenuRename: () => void;
  onClickMenuDelete: () => void;
  onClickMenuEdit: () => void;
};

export const useDropdownMenu = ({ onClickMenuRename, onClickMenuDelete, onClickMenuEdit }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.actions' });

  return (
    <Menu
      onClick={({ domEvent }) => domEvent.stopPropagation()}
      items={[
        {
          key: '1',
          onClick: onClickMenuRename,
          label: t('rename'),
        },

        {
          key: '2',
          onClick: onClickMenuEdit,
          label: t('edit'),
        },
        {
          key: '3',
          danger: true,
          onClick: onClickMenuDelete,
          label: t('delete'),
        },
      ]}
    />
  );
};
